<template>
  <b-card no-body>
    <b-card-body>
      <b-row>
        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <b-form-group
            id="input-group-3"
            :label="$t('edu_programs.program_type')"
            label-for="input-3"
          >
            <v-select
              v-model="filters.type"
              :options="programType"
              class="w-100"
              :reduce="(val) => val.id"
              label="name"
              @input="(val) => $emit('update', filters)"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <b-form-group
            id="input-group-3"
            :label="$t('program_lists.program_list')"
            label-for="input-3"
          >
            <v-select
              v-model="filters.program_list"
              :options="program_listOptions"
              class="w-100"
              label="name"
              :reduce="(type) => type.id"
               @input="(val) => $emit('update', filters)"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <b-form-group
            id="input-group-3"
            :label="$t('edu_seasons.edu_season')"
            label-for="input-3"
          >
            <v-select
              v-model="filters.edu_seasonOption"
              :options="edu_seasonOptions"
              class="w-100"
              label="name"
              :reduce="(type) => type.id"
               @input="(val) => $emit('update', filters)"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import Program_listsController from "@/Controllers/Program_listsController";
import vSelect from "vue-select";
import Controller from "../../../../Controllers/EduProgramsController";
import Edu_seasonsController from "@/Controllers/Edu_seasonsController";
import { values } from "postcss-rtl/lib/affected-props";
let controller = new Controller();

export default {
  props: ["filters"],
  components: {
    vSelect,
  },
  data() {
    return {
      programType: [],
      program_listOptions: [],
      edu_seasonOptions: [],
    };
  },
  async created() {
    this.programType = controller.programType().map((a) => {
      return { name: this.$i18n.t(`edu_programs.${a}`), id: a };
    });
    this.program_listOptions = await new Program_listsController().GetAll();
    this.edu_seasonOptions = await new Edu_seasonsController().GetAll();
  },
  methods: {
    
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
